<script>
   /**************************************************************/
   /* Svelte component for selection of plot type            */
   /**************************************************************/

   export let value = 'p';
   export let options = ['p', 'l', 'b', 'h', 'ml', 'bp', 'hm'];

   /**
    * Handler of event when changes are made by pressing left and right arrows
    * @param e
    */
   const changeOption = (e) => {
      if (e.key === 'ArrowLeft') {
         const ind = options.findIndex(v => v === value);
         if (ind > 0) {
            value = options[ind - 1];
         }
         return
      }

      if (e.key === 'ArrowRight') {
         const ind = options.findIndex(v => v === value);
         if (ind < options.length) {
            value = options[ind + 1];
         }
         return
      }
   }
</script>


<div on:keydown={changeOption} role="radiogroup" tabindex="0" class="selector">
   {#each options as option (option)}
   <button on:click={() => value = option} class="option option_{option}" class:selected={option==value}>
   {@html option}
   </button>
   {/each}
</div>
<input name='plot-type-selector' bind:value={value}>


<style>
   input {
      display: none;
   }

   .selector {
      position: relative;
      box-sizing: border-box;
      flex: 1 1 auto;
      font-size: 1em;
      line-height: 1.5em;
      margin: 0;
      padding: 0.15em 0;
      width: auto;
      border-radius: 2px;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      display: flex;
   }

   .option {
      cursor: default;
      padding: 0.25em 0.5em;
      margin: 0 0.2em 0 0;
      color: #606060;
      background-color: #f0f0f0;
      border: 1px solid transparent;

      width: 36px;
      height: 24px;
      background-size: 32px 20px;
      background-repeat: no-repeat;
      background-position: 50%;
      font-size: 0;
      border-radius: 2px;
      margin-right: 2px;
   }


   .option.selected {
      background-color: #6EB8FF;
      color: #fefefe;
   }

   .option:not(.selected):hover {
      border: 1px solid #66abec;
      background-color: #6eb8ff20;
      color: #4777a4;
   }
   /*
   colors:
   %23606060
   %23fefefe
   %236EB8FF
   */

   .option_bp {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%23606060" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%23606060" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%23606060" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%23606060" stroke-width="2"/></svg>');
   }

   .option_bp.selected:hover,
   .option_bp.selected {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%23fefefe" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%23fefefe" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%23fefefe" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%23fefefe" stroke-width="2"/></svg>');
   }

   .option_bp:hover {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="15" width="10" height="16" transform="rotate(-90 8 15)" stroke="%236EB8FF" stroke-width="2"/><line x1="15" y1="14" x2="15" y2="4" stroke="%236EB8FF" stroke-width="2"/><line x1="30" y1="10" x2="25" y2="10" stroke="%236EB8FF" stroke-width="2"/><line x1="8" y1="10" x2="2" y2="10" stroke="%236EB8FF" stroke-width="2"/></svg>');
   }


   /* heat map */
   .option_hm {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%23606060" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%23606060" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%23606060" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%23606060" stroke-width="2"/></svg>');
   }

   .option_hm.option_hm.selected:hover,
   .option_hm.selected {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%23fefefe" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%23fefefe" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%23fefefe" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%23fefefe" stroke-width="2"/></svg>');
   }

   .option_hm:hover {
      background-image: url('data:image/svg+xml;utf8,<svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="16" width="12" height="23" transform="rotate(-90 5 16)" stroke="%236EB8FF" stroke-width="2"/><line x1="13" y1="16" x2="13" y2="3" stroke="%236EB8FF" stroke-width="2"/><line x1="21" y1="16" x2="21" y2="3" stroke="%236EB8FF" stroke-width="2"/><line x1="28" y1="10" x2="5" y2="10" stroke="%236EB8FF" stroke-width="2"/></svg>');
   }


   /* line */
   .option_l {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_l.selected:hover,
   .option_l.selected {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_l:hover {
      background-image: url('data:image/svg+xml;utf8,');
   }


   /* scatter */
   .option_p {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_p.selected:hover,
   .option_p.selected {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_p:hover {
      background-image: url('data:image/svg+xml;utf8,');
   }


   /* bar */
   .option_h {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_h.selected:hover,
   .option_h.selected {
      background-image: url('data:image/svg+xml;utf8,');
   }

   .option_h:hover {
      background-image: url('data:image/svg+xml;utf8,');
   }

</style>